import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import {adaptLoginResponse} from "./login.adapter";
import type {LoginApiResponse, LoginRequest, LoginResult} from "./login.types";

export const loginService = async (payload: LoginRequest): Promise<LoginResult> => {
  const response = await httpRequest<LoginApiResponse, LoginRequest>({
    method: "POST",
    url: "/auth/login",
    baseUrl: config.apiRootUrl,
    body: payload,
    auth: false,
  });
  return adaptLoginResponse(response);
};
